import { DefaultInfiniteList } from "../../../../-components/InfiniteList"
import { DefaultListItem } from "../../../../-components/default-list/list-item"
import { SuspenseWithErrorBoundary } from "../../../../-components/suspense"
import { useTranslation } from "react-i18next"
import { ResourceCard } from "./ResourceCard"
import {
  FieldData,
  ResourceDto,
  ResourceDtoPagination,
} from "@/orval/gen/model"
import { InfiniteData, UseInfiniteQueryResult } from "@tanstack/react-query"

interface Props {
  queryResult: UseInfiniteQueryResult<
    InfiniteData<ResourceDtoPagination, unknown>,
    Error
  >
  onClickItem: (item: ResourceDto) => void
}

export function ResourcesCardList({ queryResult, onClickItem }: Props) {
  const [expanded, setExpanded] = React.useState(false)
  const { t } = useTranslation("app_server")
  return (
    <SuspenseWithErrorBoundary>
      <DefaultInfiniteList
        w={"100%"}
        justify={"flex-start"}
        queryResult={queryResult}
        renderItem={({ entity }) => (
          <DefaultListItem
            maw={"100%"}
            style={{ flex: "1 0 300px", minWidth: 0 }}
            onClick={() => onClickItem(entity)}
          >
            <ResourceCard
              resourceId={entity.resourceId}
              title={[entity.resourceType, entity.name]
                .filter(Boolean)
                .join(" / ")}
              attachments={entity.attachments}
              defaultFields={[
                {
                  label: t("Available"),
                  value: entity.availableCount + "/" + entity.count,
                },
              ]}
              fieldData={
                entity.resourceFields
                  .filter((rf) => !!rf.value)
                  .flatMap((f) => f.value)
                  .filter((f) => !!f) as FieldData[]
              }
            />
          </DefaultListItem>
        )}
        direction={"row"}
        wrap={"wrap"}
      />
    </SuspenseWithErrorBoundary>
  )
}
